import { useEffect, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { isGameSoundOn, onGameSoundChange, setGameSoundOn, unlockGameAudio } from '../synth';

/** The shared hook: current sound preference, kept in step with toggles elsewhere. */
export function useGameSound(): [boolean, (on: boolean) => void] {
  const [on, setOn] = useState(isGameSoundOn);
  useEffect(() => onGameSoundChange(setOn), []);
  return [on, setGameSoundOn];
}

/** 44px round speaker button — one per-device preference for every game. */
export function SoundToggle({ className = '' }: { className?: string }): JSX.Element {
  const [on, set] = useGameSound();
  return (
    <button
      type="button"
      data-testid="game-sound-toggle"
      aria-label={on ? 'Sound on' : 'Sound off'}
      aria-pressed={on}
      onClick={() => {
        unlockGameAudio();
        set(!on);
      }}
      className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-line text-fg-2 ${className}`}
    >
      {on ? <Volume2 size={18} aria-hidden="true" /> : <VolumeX size={18} aria-hidden="true" />}
    </button>
  );
}
